import React from 'react';
import { Plus } from 'lucide-react';
import { cn } from 'lib/utils';

interface CreateTileProps {
  label: string;
  onClick: () => void;
  className?: string;
}

/** The dashed "+ New …" cell that opens a create flow from inside a card grid (Library, Groups, group materials). */
export function CreateTile({ label, onClick, className }: CreateTileProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'flex min-h-[148px] flex-col items-center justify-center gap-2 rounded-lg border border-dashed border-muted-foreground/35 bg-card px-4 text-[13.5px] font-medium text-foreground/80 transition-colors hover:border-muted-foreground/60 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        className,
      )}
    >
      <Plus className="h-5 w-5 text-muted-foreground" aria-hidden />
      {label}
    </button>
  );
}

export default CreateTile;
